import * as React from "react";

import * as styles from './BreadCrumbs.module.css';

const Breadcrumbs = ({ crumbs }) => {
  let crumbsOutput = crumbs;
  if (crumbsOutput && typeof crumbsOutput !== 'object') {
    if (crumbsOutput.indexOf('>') > -1) {
      crumbsOutput = crumbsOutput.split('>');
    } else {
      crumbsOutput = [crumbsOutput];
    }
  }
  return (
    <ul className="menu-list" key="menu-list">
      {crumbsOutput &&
        crumbsOutput.map((crumb, crumbIndex) => (
          <React.Fragment key={crumbIndex}>
            {crumb.label !== undefined && typeof crumb === 'object' && 'link' in crumb && (
              <li key= {crumbIndex} >
                <a href={crumb.link}>
                {crumb.label?.trim()}
              </a>
              </li>
            )}
            {crumb.label !== undefined && typeof crumb === 'object' && !('link' in crumb) && (
              <li key={crumbIndex} >
                {crumb.label?.trim()}
                </li>
            )}
            {typeof crumb !== 'object' && (
              <li key={crumbIndex} >
                {crumb.trim()}
                </li>
            )}
            </React.Fragment>
        ))}
        </ul>
  );
};

export default Breadcrumbs;
